var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _rect10, _path4, _path5, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstButtonMmk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 96,
    viewBox: "0 0 136 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 23,
    width: 42,
    height: 55,
    rx: 8,
    fill: "#DEF0F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 14,
    width: 56,
    height: 69,
    rx: 5,
    fill: "#204568"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 18,
    width: 48,
    height: 61,
    rx: 3,
    fill: "#DEF0F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#E9F4F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 57.3999,
    y: 28.875,
    width: 22.5,
    height: 3.00872,
    rx: 1.50436,
    fill: "#4A6F93"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 47,
    width: 29,
    height: 3,
    rx: 1.5,
    fill: "#A8D7BA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 65,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#A8D7BA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 57.3999,
    y: 34.8926,
    width: 16.5,
    height: 3.00873,
    rx: 1.50436,
    fill: "#4A6F93"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 56,
    width: 21,
    height: 3,
    rx: 1.5,
    fill: "#A8D7BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 48.936L43.5 50.4404L46.5 47.4316",
    stroke: "#E05A77",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57.9624L43.5 59.4667L46.5 56.458",
    stroke: "#E05A77",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66.9882L43.5 68.4926L46.5 65.4839",
    stroke: "#E05A77",
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 30.5215,
    width: 5.99999,
    height: 49.6439,
    fill: "#E05A77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98 24C98 23.4477 98.4477 23 99 23H103C103.552 23 104 23.4477 104 24V29.0174H98V24Z",
    fill: "#A8D7BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98 80.1655H104L101 87.6873L98 80.1655Z",
    fill: "#F2D0B2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 18,
    width: 25,
    height: 4,
    fill: "#204568"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstButtonMmk);
export default __webpack_public_path__ + "static/media/first_button_mmk.df314c0f01d18b6bae06498af4bce41c.svg";
export { ForwardRef as ReactComponent };